import type { LineItem } from 'types';

const groupId = (item: LineItem): string => String(item.parent_line_item_id ?? item.id);

export const filterLineItemGroups = (items: LineItem[], matches: (_item: LineItem) => boolean): LineItem[] => {
  const matchingGroups = new Set(items.filter(matches).map(groupId));
  return items.filter(item => matchingGroups.has(groupId(item)));
};
